/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-undef */
import React, { useState, useEffect, lazy, Suspense } from "react";
import "./App.css";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import Header from "./components/Header";
import RatesSection from "./components/RatesSection";
import PartnerBenefits from "./components/PartnerBenefits";
import ApplyNow from "./components/ApplyNow";
import WhySunWest from "./components/WhySunWest";
import NewFooter from "./components/NewFooter/index";
import PricingTable from "./components/PricingTable";
import Spinner from "react-bootstrap/Spinner";
import HeaderMobile from "./components/headermobile";
import MediaQuery from "react-responsive";
import { CookieSetting } from "cookiesetting-component";
import axios from "axios";
import jsonData from "./components/ai-branding.json";
import { useHyperlink } from "./contexts/HyperlinkProvider";
const AnchorLink = lazy(() => import("react-anchor-link-smooth-scroll"));
const ApplyNowForm = lazy(() => import("./components/ApplyNowForm"));
const SignUpForm = lazy(() => import("./components/SignUpForm"));

function App() {
  const [download, setDownload] = useState(false);
  const appVersion = appversion.version;
  const [links, setLinks] = useState(null);
  const [guidelineurlData, setGuidelineurlData] = useState();
  const [textData, setTextData] = useState();
  const [wholesaleurlData, setWholesaleurlData] = useState();
  const [correspondanturlData, setCorrespondanturlData] = useState();

  const [angelAiLink, setAngelAiLink] = useState('');
  const [sunwestLink, setSunWestLink] = useState('');
  const [sunwestFullLink, setSunWestFullLink] = useState('');
  const [celligenceLink, setCelligenceLink] = useState('');
  const [celligenceLlcLink, setCelligenceLlcLink] = useState('');
  const [pavanLink, setPavanLink] = useState('');
  const { getHyperLink } = useHyperlink();

  useEffect(() => {
    const processContent = async () => {
      setAngelAiLink(await getHyperLink('websites', 'angelai', 0));
      setSunWestLink(await getHyperLink('websites', 'swmc', 0));
      setSunWestFullLink(await getHyperLink('websites', 'swmc', 1));
      setCelligenceLink(await getHyperLink('websites', 'celligence', 1));
      setCelligenceLlcLink(await getHyperLink('websites', 'celligence', 0));
      setPavanLink(await getHyperLink('profiles', 'pavan', 0));
    };
    processContent();
  }, [getHyperLink]);

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ANGELAI_JSON + '?t=' + Date.now());
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        // You can choose to handle the error here if needed
      }
    };

    fetchLinks(); // Always fetch data from process.env.REACT_APP_ANGELAI_JSON

  }, []);

  useEffect(() => {
    const fetchGuidelineURLJSON = async () => {
      await axios.get(process.env.REACT_APP_WHOLESALEANDCORRESPONDENT_GUIDELINES_URL + '?t=' + Date.now()).then(
        (response) => {
          const guidelineurlJsonData = response.data;
          setGuidelineurlData(guidelineurlJsonData);
          setTextData(guidelineurlJsonData.Text);
          setWholesaleurlData(guidelineurlJsonData[0].urlWholesale);
          setCorrespondanturlData(guidelineurlJsonData[1].urlCorrespondant);
        },
        (error) => {
          console.log(error);
        }
      );
    };
    fetchGuidelineURLJSON();
  }, []);

  //use morgan widet
  useEffect(() => {
    async function onLoadMorgan() {
      if (document.readyState === "complete" || (document && document.body)) {
        (function (w, d, s, a, g, e, o) {
          w[g] =
            w[g] ||
            function () {
              (w[g].q = w[g].q || []).push(arguments);
            };
          var l = d.createElement("div");
          l.id = "mini-Morgan-chat-widget";
          d.getElementsByTagName("body")[0].appendChild(l);
          e = d.createElement(s);
          o = d.getElementsByTagName(s)[0];
          e.async = 1;
          e.src = a;
          e.setAttribute("type", "text/javascript");
          o.parentNode.insertBefore(e, o);
        })(
          window,
          document,
          "script",
          "https://d2w24n4g34usfg.cloudfront.net/morgan/widget/index.js",
          "mmc"
        );
        mmc(350, 560, "left", 10, 10, 10000);
      }
    }

    window.addEventListener("load", onLoadMorgan, true);

    return () => window.removeEventListener("load", onLoadMorgan);
  }, [document.readyState]);

  //Below function check if the user already submitted the form and allow it to  download the spreadsheet.
  const setDownloadState = (downloadForm) => {
    setDownload(downloadForm);
  };

  return (
    <>
      <CacheBuster
        currentVersion={appVersion}
        isEnabled={true} //If false, the library is disabled.
        isVerboseMode={false}
      >
        <React.Fragment>
          <MediaQuery minWidth={768}>
            <Header wholesaleurlData={wholesaleurlData} sunwestLink={sunwestLink} />
          </MediaQuery>
          <MediaQuery maxWidth={767}>
            <HeaderMobile wholesaleurlData={wholesaleurlData} sunwestLink={sunwestLink} />
          </MediaQuery>
          <PricingTable downloadRateSheet={download} sunwestLink={sunwestLink} sunwestFullLink={sunwestFullLink} celligenceLink={celligenceLink} celligenceLlcLink={celligenceLlcLink} />
          <RatesSection links={links} angelAiLink={angelAiLink} sunwestLink={sunwestLink} />
          <PartnerBenefits links={links} angelAiLink={angelAiLink} sunwestLink={sunwestLink} sunwestFullLink={sunwestFullLink} celligenceLink={celligenceLink} celligenceLlcLink={celligenceLlcLink} />
          <Suspense
            fallback={
              <div className="text-center">
                <Spinner />
              </div>
            }
          >
            <AnchorLink
              href="#applyNowForm"
              style={{
                textDecoration: "none",
              }}
            >
              <ApplyNow btnTitle="Learn More" />
            </AnchorLink>
          </Suspense>
          <WhySunWest sunwestLink={sunwestLink} />
          <Suspense fallback={<div />}>
            <SignUpForm angelAiLink={angelAiLink} sunwestLink={sunwestLink} sunwestFullLink={sunwestFullLink} celligenceLink={celligenceLink} celligenceLlcLink={celligenceLlcLink} pavanLink={pavanLink} />
          </Suspense>
          <NewFooter angelAiLink={angelAiLink} sunwestLink={sunwestLink} sunwestFullLink={sunwestFullLink} celligenceLink={celligenceLink} celligenceLlcLink={celligenceLlcLink} />
          <CookieSetting 
            privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
            configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
            analytics={process.env.REACT_APP_ANALYTICS_PATH}
          />
        </React.Fragment>
      </CacheBuster>
    </>
  );
}

export default App;
